import { BookingDetails } from 'components/bookings/BookingDetails'
import { LoadingBackdrop } from 'components/common'
import { Mode } from 'constants/index'
import { BookingAddressType, useGetUserQuoteQuery } from 'generated/graphql'
import { mapToBookingAddressForm } from 'helpers'
import { TBookingForm } from 'types/form-types'

interface IProps {
  copyFromId: number
}

const CustomerCopyQuoteDetails = (props: IProps) => {
  const { copyFromId } = props

  const { data, loading } = useGetUserQuoteQuery({
    variables: { quoteId: copyFromId },
    fetchPolicy: 'network-only',
  })

  const sourceBooking = data?.userBooking

  const preFilledFields: Partial<TBookingForm> = sourceBooking
    ? {
        collectionAddresses: sourceBooking.addresses
          .filter((addr) => addr.type === BookingAddressType.Collection)
          .map(mapToBookingAddressForm),
        deliveryAddresses: sourceBooking.addresses
          .filter((addr) => addr.type === BookingAddressType.Delivery)
          .map(mapToBookingAddressForm),
        tariffId: sourceBooking.tariffId != null ? String(sourceBooking.tariffId) : '',
        isWaitAndReturn: sourceBooking.isWaitAndReturn,
      }
    : {}

  if (loading) {
    return <LoadingBackdrop loading={true} />
  }

  return (
    <BookingDetails
      bookingId={null}
      mode={Mode.Create}
      isQuote
      preFilledFields={preFilledFields}
      autoCalculateDistance
    />
  )
}

export default CustomerCopyQuoteDetails
